window.addEventListener('alpine:init', () => {
  function productReviews(data = {}) {
    return {
      ...data,

      isLoadingProductReviews: true,

      isIntersectedProductReviews: false,

      onIntersect() {
        this.isIntersectedProductReviews = true;
      },

      onEffect() {
        if (this.isIntersectedProductReviews && window.jdgm) {
          this.$nextTick(() => {
            window.jdgm.loadJS(`${window.jdgm.CDN_HOST}loader.js`);

            setTimeout(() => {
              this.isLoadingProductReviews = false
            }, 1000);
          });
        }
      }
    };
  };

  Alpine.data('productReviews', productReviews);
});
